import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainerBase from 'remote-com-shared/components/ContentContainer';
import { SectionWrapper } from 'remote-com-shared/components/SectionWrapper';
import {
  groupFieldHasContent,
  transformProperties,
} from 'remote-com-shared/domains/prismic/helpers';
import styled from 'styled-components';

import { DescriptionComponent, TitleComponent } from '../sharedStyles';

import { fieldHasContent } from '@/src/domains/prismic/helpers';
import { defaultPrismicComponents } from '@/src/domains/prismic/render';

const ContentContainer = styled(ContentContainerBase)`
  display: flex;
  flex-direction: column;

  ${TitleComponent} {
    color: var(--color-tone-primary);
    margin: 0;

    & > * {
      margin: 40px 0;
    }
  }

  ${DescriptionComponent} {
    font-size: 16px;
  }
`;

export function StatsSectionSlice({ slice }) {
  const { primary, fields } = transformProperties(slice);
  const { title, description, image } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {image && <Image src={image.url} {...image.dimensions} alt={image.alt || ''} />}
        {fieldHasContent(title) && (
          <TitleComponent>
            <PrismicRichText field={title} />
          </TitleComponent>
        )}
        {fieldHasContent(description) && (
          <DescriptionComponent>
            <PrismicRichText field={description} components={defaultPrismicComponents} />
          </DescriptionComponent>
        )}
        {groupFieldHasContent(fields, 'stat') && <StatsSection {...{ fields }} />}
      </ContentContainer>
    </SectionWrapper>
  );
}

const StatsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 32px;
`;

const StatContainer = styled.div`
  text-align: center;
`;

const Stat = styled.div`
  color: var(--color-tone-primary);
  font-size: 64px;
`;

const StatDescription = styled.div`
  color: var(--color-tone-font);
  max-width: 100px;
  margin: 0 auto;
`;

function StatsSection({ fields }) {
  return (
    <StatsContainer>
      {fields.map(({ stat, statDescription }, index) => (
        <StatContainer key={index}>
          {stat && <Stat>{stat}</Stat>}
          {statDescription && <StatDescription>{statDescription}</StatDescription>}
        </StatContainer>
      ))}
    </StatsContainer>
  );
}
